module.exports = __webpack_public_path__ + "static/media/1 16 vert.ad24b4e3.mp3";